module.exports = __webpack_public_path__ + "images/icon-subgroup-92e06cb1704f7facaf6c9f30b765ac7c.svg";